export enum LaneType {
  allLanesCompleteCarriageway,
  busLane,
  centralReservation,
  hardShoulder,
  lane1,
  lane2,
  lane3,
  lane4,
  lane5,
  lane6,
  lane7,
  lane8,
  lane9,
  rushHourLane,
  tidalFlowLane
}



// WEBPACK FOOTER //
// ./src/app/models/enums/lanetype.ts